export default "__VITE_ASSET__BQwa2Nv9__"